import React from 'react';
import { usePublic } from '../contexts/PublicContext';
import Dashboard from '../pages/Dashboard';

const PublicDashboard: React.FC = () => {
  const { token, linkInfo, isLoading, error } = usePublic();

  // Verificar se o token existe
  if (!token) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Token não encontrado</h1>
          <p className="text-gray-600">A URL deve conter um token válido</p>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-gray-600">A carregar dashboard público...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Erro ao carregar</h1>
          <p className="text-gray-600 mb-4">{error}</p>
          <p className="text-sm text-gray-500">Verifique se o link está correto e tente novamente.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header público */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Dashboard Público</h1>
              <p className="text-gray-600">
                {linkInfo ? `${linkInfo.link_name} • ${linkInfo.user_email}` : 'Visão geral do portefólio de investimentos'}
              </p>
            </div>
            <div className="flex items-center space-x-2 text-sm text-gray-500">
              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
              <span>Valores sensíveis ocultos</span>
            </div>
          </div>
        </div>
      </div>

      {/* Usar o Dashboard original - SensitiveValue detecta automaticamente que é dashboard público */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Dashboard />
      </div>

      {/* Footer */}
      <div className="bg-white border-t">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="text-center text-sm text-gray-500">
            <p>Dashboard público • Valores sensíveis ocultos por privacidade</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicDashboard;